<!--
 * @Descripttion: 
 * @version: 0.1
 * @Author: lixianbing
 * @Date: 
 * @LastEditors: lixianbing
 * @LastEditTime: 2020-4-16
 -->
<template>
  <div class="home">
    <!-- 顶部模块 -->
    <div class="box">查询中...</div>
  </div>
</template>

<script>
      import {
      
        activity_file
    } from '@/api/file' // 接口导入
    export default {
      
        components: {
         
          
        },
        computed: {
           
        },
        data() {
            return {
               
                }
                    },
        
        created() {

        },
        mounted() {
         this.ss();

        },
        methods: {
                ss(){
                  let a = window.localStorage.getItem("value")
                  let b = window.localStorage.getItem("cy")
                  if(a!=null && b!=null){
                    this.$router.push('/pageindex')
                  }  
              },
             //活动附件
             activeup(){
              
             }
        },

    }
</script>

<style scoped="" lang="scss">
.home {
  background: white;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 6px 0px rgba(43, 43, 43, 0.05);
  border-radius: 6px;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  .box {
    margin: auto;
    height: 100%;
    width: 100%;
    text-align: center;
    font-size: 26px;
    line-height: 300px;
  }
}
</style>


